
<ng-template #content let-c="close" let-d="dismiss">
  <div class="confirm-dialog">
    <div class="confirm-dialog__header">
      <div class="confirm-dialog__icon">
        <i class="fa-solid fa-triangle-exclamation"></i>
      </div>
      <div>
        <h3 class="confirm-dialog__title">{{headerMessage || 'Confirm'}}</h3>
        <p class="confirm-dialog__message">{{bodyMessage || 'Are you sure?'}}</p>
      </div>
    </div>
    <div class="confirm-dialog__actions">
      <button type="button" class="cancel-btn" [disabled]="isLoading" (click)="cancel()">{{ rejectLabel }}</button>
      <button type="button" class="accept-btn" [disabled]="isLoading" (click)="accept()">
        <i *ngIf="isLoading" class="fa-spin fas fa-spinner me-2"></i>
        {{ acceptLabel }}
      </button>
    </div>
  </div>
</ng-template>
